<template>
  <div class="map_box" ref="map">
    <div class="map"></div>
  </div>
</template>
<script>
import mapImage from "@/assets/images/map.png";
export default {
  mounted() {
    this.changeMap();
    this.map = null;
    this.AMap = null;
    this.markers = [];
  },
  methods: {
    initMap() {
      window._AMapSecurityConfig = {
        securityJsCode: "1600e3767fcaa3622c40cc08ee945d27",
      };
      // 13cecb465bbd88a3d702010c7bbcd583
      AMapLoader.load({
        key: "92339dc4ffff5225b6eba4f35ae276ca", //申请好的Web端开发者 Key，调用 load 时必填
        version: "2.0", //指定要加载的 JS API 的版本，缺省时默认为 1.4.15
      })
        .then((AMap) => {
          this.AMap = AMap;
          let dis = this.getDis(AMap);
          this.map = new AMap.Map(this.$refs.map, {
            layers: [dis],
            center: [170.451348, 43.792165],
            zoom: 1,
            zooms: [1, 2],
            //   viewMode: "3D",
            showLabel: false,
          });
          this.map.on("complete", () => {
            // 在地图准备就绪时执行一些操作
            console.log("地图已准备就绪");
            this.$emit("complete");
          });
          this.$emit("ready");
        })
        .catch((e) => {
          console.error(e); //加载错误提示
        });
    },
    getDis(AMap) {
      var dis = new AMap.DistrictLayer.World({
        mapStyle: "amap://styles/13cecb465bbd88a3d702010c7bbcd583",
        zIndex: 10,
        styles: {
          "stroke-width": 0.8,
          fill: function (d) {
            return "#a5a5a5";
          },
          "coastline-stroke": function (d) {
            return "rgba(0,0,0,0)";
          },
          "nation-stroke": function (d) {
            return "#a5a5a5";
          },
        },
      });
      return dis;
    },
    changeMap() {
      if (window.ResizeObserver) {
        let resizeObserver = new window.ResizeObserver(() => {
          this.$imgLoading(mapImage).then(({ per }) => {
            console.log(per);
            if (this.$refs.map) {
              let mpaboxWidth = this.$refs.map.offsetWidth; //* 0.3333;
              this.$refs.map.style = `height:${mpaboxWidth / per}px`;
              if (!this.map) {
                this.initMap();
              } else {
                this.map.setFitView();
              }
            }
          });
        });
        resizeObserver.observe(this.$refs.map);
      }
    },
    addMarker(list) {
      this.markers = [];
      list.forEach((item, index) => {
        let { longitude, latitude, image } = item;
        const content = `<div class="marker">
            <div class="country_img fi fi-${image}"></div>
          </div>`;
        const marker = new this.AMap.Marker({
          content: content, // 自定义点标记覆盖物内容
          position: [parseFloat(longitude), parseFloat(latitude)], // 基点位置
          offset: new this.AMap.Pixel(-12.5, -28), // 相对于基点的偏移位置
        });
        if (index == 0) {
          marker.dom.className = "amap-marker active";
        }

        marker.on("click", (e) => {
          let doms = e.target.dom.parentElement.children;
          for (let i = 0, len = doms.length; i < len; i++) {
            let child = doms[i];
            child.className = "amap-marker";
          }
          // 在标记点击时执行的操作
          e.target.dom.className = "amap-marker active";
          this.$emit("marker", { item, e });
        });
        this.markers.push(marker);

        this.map.add(marker);
      });
      this.map.setFitView(this.markers);
    },
  },
};
</script>

<style lang="scss" scoped>
$max-width: 500px;
.map_box {
  width: 100%;
  height: 100vh !important;
  @media screen and (max-width: $max-width) {
    width: 100%;
    height: 100vh !important;
  }
  ::v-deep .marker {
    width: 25px;
    height: 30px;
    background: url("../../assets/images/show_icon.png") no-repeat center center;
    background-size: 100% 100%;
    opacity: 1;
    cursor: pointer;
    position: relative;
    &:hover {
      background: url("../../assets/images/active_show.png") no-repeat center
        center;
      background-size: 100% 100%;
    }
  }
  ::v-deep .amap-marker.active .marker {
    background: url("../../assets/images/active_show.png") no-repeat center
      center;
    background-size: 100% 100%;
  }
  ::v-deep .amap-logo {
    display: none !important;
  }
  ::v-deep .amap-copyright {
    display: none !important;
  }
  ::v-deep .country_img {
    width: 20px;
    height: 15px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -17px;
    // background-color: red;
  }
  .map {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
}
</style>
